import Vue from 'vue'
import VueRouter from 'vue-router'
import api from '@/config/api/users'

import store from '../store'
Vue.use(VueRouter)

const getAccessToken = () => {
  return document.cookie
      .split(';')
      .find(cookie => cookie.trim().startsWith('access_token'))
      ?.split('=')[1];
}

const checkAuthStatus = async () => {
  const token = getAccessToken();
  if (token && !store.getters.isLogged) {
    try {
      const user = await api.getUserInfo();
      store.commit("setUser", user);
      return true;
    } catch (error) {
      return false;
    }
  }
  return store.getters.isLogged;
}


const beforeEnterAdmined = () => (to, from, next) => {
  if (store.getters.isLogged && store.state.user.level === 0)
    return next()
  else
    return next('/')
}

const routes = [
  {path: '/error', name: 'Error', text: 'Error', component: () => import('@/components/Error')},
  {path: '/oauth', name: 'OAuth', text: 'OAuth',meta: {layout: false}, component: () => import('@/components/auth/OAuth')},
  {path: '/project', component: () => import('@/components/gitlab/Projects'), name: ''},
  {path: '/dashboard', component: () => import('@/components/dashboard/Swarm'), name: ''},
  {path: '/login', name: 'Login', text: 'Login', component: () => import('@/components/auth/Login')},
  {path: '/mgmt/user', component: () => import('@/components/user/UserMgmt'), name: '', beforeEnter: (to, from, next) => store.getters.isAdmin ? next() : next('/dashboard')},
  {path: '*', redirect: '/dashboard'},
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(async (to, from, next) => {
  // Skip auth check for login and OAuth routes
  if (to.path === '/oauth') return next();
  if (to.path === '/login') {
    if (await checkAuthStatus()) {
      return next('/dashboard');
    }
    return next();
  }

  // Check auth status for protected routes
  const isAuthenticated = await checkAuthStatus();

  if (!isAuthenticated && to.path !== '/login') {
    // Save intended destination
    return next(`/login?to=${encodeURIComponent(to.fullPath)}`);
  }

  next();
})

export default router
